












import NoteModal from "./NoteModal.vue";

export default {
    name: "NoteButton",
    components: { NoteModal },
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
        openModal: function () {
            this.showModal = true;
        },
        closeModal: function () {
            this.showModal = false;
        },
    },
};
